import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(horoscope)/horoscope/components/RouteFade.tsx");
